module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg2-4d0e46fafefc19feb01cc91f5d81c701.jpg";